"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegalStatusImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing LegalStatus operations. */
var LegalStatusImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class LegalStatus class.
   * @param client Reference to the service client
   */
  function LegalStatusImpl(client) {
    (0, _classCallCheck2["default"])(this, LegalStatusImpl);
    this.client = client;
  }
  /**
   * Returns the legal status of the document for danish law
   * @param portalId
   * @param documentId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(LegalStatusImpl, [{
    key: "getDocumentLegalStatus",
    value: function getDocumentLegalStatus(portalId, documentId, options) {
      var operationArguments = {
        portalId: portalId,
        documentId: documentId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentLegalStatusOperationSpec);
    }
  }]);
  return LegalStatusImpl;
}(); // Operation Specifications


exports.LegalStatusImpl = LegalStatusImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getDocumentLegalStatusOperationSpec = {
  path: "/api/Portals({portalId})/legal/status/{documentId}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Enum",
          allowedValues: [0, 1, 2, 3, 4, 5]
        }
      }
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};